import { render, staticRenderFns } from "./MtIcon.vue?vue&type=template&id=c1275de6&"
import script from "./MtIcon.vue?vue&type=script&lang=js&"
export * from "./MtIcon.vue?vue&type=script&lang=js&"
import style0 from "./MtIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports